import { PROJECT_VIEW_KEYS } from 'modules/work-implementation/constants';
import { ANALYST_PRIMARY_STEPS, ANALYST_PRIMARY_STEP_KEYS } from '../constants';

// commonDetails: {
//   name: raw.job_name,
//   date: jobDate,
//   code: raw.job_code,
//   status: raw.job_status,
//   owner: raw.owner?.name,
//   value: jobValue,
//   totalMilestones: raw.milestone_count,
//   completedMilestones: raw.milestones_completed,
// },

// export const ANALYST_PRIMARY_STEPS = [
//   { label: "Job Information", key: "jobInformation" },
//   { label: "Milestones", key: "milestones" },
//   { label: "Work Progress", key: "workProgress" },
//   { label: "Completed", key: "completed" },
// ];

export function getPrimaryStepperSteps(projectData) {
  const steps = ANALYST_PRIMARY_STEPS;

  if (!projectData) {
    return steps;
  }

  const milestones = projectData.completedMilestones;
  const totalMilestones = projectData.totalMilestones;
  const milestonesInProgress = milestones > 0 && milestones < totalMilestones;
  const milestonesCompleted = milestones >= totalMilestones;

  const milestonesStep = steps.find((step) => step.key === ANALYST_PRIMARY_STEP_KEYS.MILESTONES);
  const updatedMilestonesStep = {
    ...milestonesStep,
    meta: `${milestones} / ${totalMilestones}`,
    in_progress: !milestonesCompleted && milestonesInProgress,
    completed: milestonesCompleted,
  };

  const workProgressStep = steps.find(
    (step) => step.key === ANALYST_PRIMARY_STEP_KEYS.WORK_PROGRESS,
  );
  const projectStatus = projectData.status;
  const workProgressCompleted = projectStatus === PROJECT_VIEW_KEYS.COMPLETED;
  const workProgressInProgress =
    projectStatus !== PROJECT_VIEW_KEYS.NOT_STARTED &&
    projectStatus !== PROJECT_VIEW_KEYS.COMPLETED;
  const updatedWorkProgressStep = {
    ...workProgressStep,
    in_progress: !workProgressCompleted && workProgressInProgress,
    completed: workProgressCompleted,
  };

  const completedStep = steps.find((step) => step.key === ANALYST_PRIMARY_STEP_KEYS.COMPLETED);
  const updatedCompletedStep = {
    ...completedStep,
    completed: projectStatus === PROJECT_VIEW_KEYS.COMPLETED,
    disabled: projectStatus !== PROJECT_VIEW_KEYS.COMPLETED,
  };

  return steps.map((step) => {
    if (step.key === ANALYST_PRIMARY_STEP_KEYS.MILESTONES) {
      return updatedMilestonesStep;
    }
    if (step.key === ANALYST_PRIMARY_STEP_KEYS.WORK_PROGRESS) {
      return updatedWorkProgressStep;
    }
    if (step.key === ANALYST_PRIMARY_STEP_KEYS.COMPLETED) {
      return updatedCompletedStep;
    }
    return step;
  });
}
